// extracted by mini-css-extract-plugin
export var fadeInAnimation = "Step-module--fadeInAnimation--693bc";
export var scrollArea = "Step-module--scrollArea--3c9c1";
export var stepWrapper = "Step-module--stepWrapper--70606";
export var text = "Step-module--text--4bca2";
export var title = "Step-module--title--6b693";